import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import TableStyleProvider from './legacy/providers/TableStyleProvider';
import { I18nextProvider } from 'react-i18next';
import { queryClient } from './legacy/lib';
import i18n from './legacy/i18n';
import '@/legacy/utils/chartConfig';
import '@/shared/styles/index.css';
import { ToastContainer } from 'react-toastify';
import { router } from './app/router';
import App from './App';
import ErrorPage from './app/pages/ErrorPage';
import { initSentry } from './app/sentry';
import { initDeployGuards } from './app/store';
import { hydrateAuthSession } from '@/features/auth/session';

// Must run before anything else — versionGuard and the axios interceptor can
// both read the session before React renders.
hydrateAuthSession();

// Boot Sentry first so anything thrown during startup is captured.
initSentry();

// Must run before React renders — forces a full logout on a stale version,
// then keeps watching for deploys for the rest of the tab's lifetime.
initDeployGuards();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<I18nextProvider i18n={i18n}>
				<TableStyleProvider>
					{/* Last-resort net for non-route render errors (App, providers,
					    router bootstrap). Route errors are handled inside the router. */}
					<Sentry.ErrorBoundary fallback={<ErrorPage />}>
						<App />
						<RouterProvider router={router} />
						<ToastContainer />
					</Sentry.ErrorBoundary>
				</TableStyleProvider>
			</I18nextProvider>
			<ReactQueryDevtools initialIsOpen={false} />
		</QueryClientProvider>
	</React.StrictMode>,
);
